function ChevronSVG({ style, ...props }) {
    return (
        <svg
            width="48"
            height="45"
            viewBox="0 0 48 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            style={style}
        >
            <path
                d="M16.1161 38.6339C15.628 38.1457 15.628 37.3543 16.1161 36.8661L29.9822 23L16.1161 9.13388C15.628 8.64573 15.628 7.85427 16.1161 7.36612C16.6043 6.87796 17.3957 6.87796 17.8839 7.36612L32.6339 22.1161C33.122 22.6043 33.122 23.3957 32.6339 23.8839L17.8839 38.6339C17.3957 39.122 16.6043 39.122 16.1161 38.6339Z"
                fill="white"
            />
        </svg>
    );
}

export default ChevronSVG;
